import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from './ThemeContext';

const RankingModal = ({ isOpen, onClose, rankingData, userData, highlightedGameId, roomId, roomName, userId, username, gameMode }) => {
  const [activeTab, setActiveTab] = useState('global');
  const navigate = useNavigate();
  const { theme } = useTheme();
  const highlightBg = theme === 'dark' ? 'rgba(0, 200, 255, 0.18)' : 'orange';
  const highlightColor = theme === 'dark' ? '#00d4ff' : 'inherit';

  if (!isOpen) return null;

  const handleGoToRankings = () => {
    navigate('/rankings', {
      state: {
        roomId,
        roomName,
        userId,
        username,
        gameMode,
        timeHorizon: rankingData?.timeHorizon ?? null,
      }
    });
  };

  const isInfiniteMode = gameMode === 'infinite';

  const renderTable = (data) => {
    if (!data || data.length === 0) {
      return (
        <div className="modal-table-container">
          <div className="no-data-message flex flex-col items-center justify-center p-8 space-y-6">
            <p className="text-xl text-gray-700 text-center max-w-md">
              For more detailed rankings and statistics, check out our rankings page!
            </p>
            <button
              onClick={handleGoToRankings}
              className="modal-centered-close-button bg-[#FF9933] hover:bg-[#FF8000] text-white font-semibold min-w-[200px]"
            >
              Go to Rankings
            </button>
          </div>
        </div>
      );
    }

    if (isInfiniteMode) {
      return (
        <div className="modal-table-container">
          <table className="modal-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Username</th>
                <th>Clicks achieved</th>
                <th>Mean Absolute Error (ms)</th>
                {/* <th>Game Finished At</th> */}
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr
                  key={index}
                  style={item.rank === highlightedGameId ? { backgroundColor: highlightBg, color: highlightColor } : {}}
                >
                  <td>{index + 1}</td>
                  <td>{item.username}</td>
                  <td>{item.click_count ?? 'N/A'}</td>
                  <td>{item.mean_absolute_error?.toFixed(3) ?? 'N/A'}</td>
                  {/* <td>{item.game_finished_at ? new Date(item.game_finished_at).toLocaleString() : 'N/A'}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <div className="modal-table-container">
        <table className="modal-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Username</th>
              <th>Mean Absolute Error (ms)</th>
              <th>Average Difference (ms)</th>
              {/* <th>Game Finished At</th> */}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr
                key={index}
                style={item.rank === highlightedGameId ? { backgroundColor: highlightBg, color: highlightColor } : {}}
              >
                <td>{index + 1}</td>
                <td>{item.username}</td>
                <td>{item.mean_absolute_error?.toFixed(3) ?? 'N/A'}</td>
                <td>{item.average_difference?.toFixed(3) ?? 'N/A'}</td>
                {/* <td>{item.game_finished_at ? new Date(item.game_finished_at).toLocaleString() : 'N/A'}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const timeHorizon = rankingData?.timeHorizon ?? 'Unknown';
  const rankings = rankingData?.ranking ?? [];
  const modalTitle = isInfiniteMode ? 'Ranking — 1s Life mode' : `Ranking for ${timeHorizon}s`;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close-button" onClick={onClose}>&times;</button>
        <h2>{modalTitle}</h2>
        <div className="tab-buttons">
          <button 
            className={activeTab === 'global' ? 'active' : ''} 
            onClick={() => setActiveTab('global')}
          >
            Global Leaderboard
          </button>
          <button 
            className={activeTab === 'user' ? 'active' : ''} 
            onClick={() => setActiveTab('user')}
          >
            My Games
          </button>
        </div>
        {activeTab === 'global' && renderTable(rankings)}
        {activeTab === 'user' && renderTable(userData)}

        <button className="modal-centered-close-button" onClick={onClose}>Try again</button>
      </div>
    </div>
  );
};

export default RankingModal;